import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router";
import { ConnectedRouter } from "react-router-redux";
import {HelmetProvider} from "react-helmet-async";

import configureApp from "./configureApp";
import App from "./components/App";
import gtmSetup from "lib/gtm/setup";

import "./assets/styles/index.css";

configureApp(({ store, history }) => {
  gtmSetup();

  ReactDOM.render(
    <HelmetProvider>
      <Provider store={store}>
        {/* ConnectedRouter will use the store from Provider automatically */}
        <ConnectedRouter history={history}>
          <Route component={App} />
        </ConnectedRouter>
      </Provider>
    </HelmetProvider>,
    document.getElementById("root")
  );
});
